<div class="header">
  <h2>Dettaglio <strong>Checklist</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a style="cursor: pointer;" [routerLink]="['/checklist']">Checklist</a></li>
      <li class="active">Dettaglio Checklist</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-list"></i>Informazioni <strong>Checklist</strong></h3>
      </div>
      <div class="panel-content">
        <h4><i class="fa fa-info-circle"></i> <strong>Titolo:</strong> {{ checklist?.name }}</h4>
        <h4><i class="fa fa-book"></i> <strong>Descrizione:</strong> {{ checklist?.description }}</h4>
      </div>
      <div *ngIf="user.fk_id_role <= 1" class="panel-footer">
        <a class="btn btn-info" (click)="openDuplicateChecklistModal()"><i class="icon-plus"></i> Duplica</a>
        <a class="btn btn-blue" [routerLink]="['/checklist/update/' + checklist.id_checklist]"><i class="icon-pencil"></i> Modifica</a>
        <a class="btn btn-danger" (click)="openDeleteChecklistModal()"><i class="icon-trash"></i> Elimina</a>
      </div>
    </div>
  </div>
  <div class="col-md-8">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-table"></i> <strong>Macro Categorie</strong></h3>
      </div>
      <div class="panel-content">
        <table *ngIf="checklistCategories.length > 0" class="table">
          <thead>
          <tr>
            <th style="width: 10%;">Codice</th>
            <th style="width: 50%;">Titolo</th>
            <th style="width: 10%;">Indice</th>
            <th class="text-right" style="width: 30%;">Azioni</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let checklistCategory of checklistCategories | paginate: paginationConfig; index as i">
            <tr>
              <td>{{ checklistCategory.code }} </td>
              <td>{{ checklistCategory.name }} </td>
              <td>{{ checklistCategory.index }} </td>
              <td class="text-right">
                <a class="edit btn btn-sm btn-white"
                   (click)="checklistSubCategories[i] = !checklistSubCategories[i]"
                   mat-raised-button
                   matTooltip="Mostra Requisiti"
                   matTooltipPosition="above">
                  <i class="fa fa-arrow-down"></i></a>
                <a class="edit btn btn-sm btn-primary"
                   [routerLink]="['/checklist-category/' + checklistCategory.id_checklist_category]"
                   mat-raised-button
                   matTooltip="Dettaglio"
                   matTooltipPosition="above">
                  <i class="fa fa-info-circle"></i></a>
                <a class="edit btn btn-sm btn-default"
                   [routerLink]="['/checklist-category/update/' + checklistCategory.id_checklist_category]"
                   mat-raised-button
                   matTooltip="Modifica"
                   matTooltipPosition="above">
                  <i class="icon-note"></i></a>
                <a class="delete btn btn-sm btn-danger"
                   (click)="openDeleteChecklistCategoryModal(checklistCategory)"
                   mat-raised-button
                   matTooltip="Elimina"
                   matTooltipPosition="above">
                  <i class="icons-office-52"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="checklistSubCategories[i]">
              <td colspan="4">
                <table *ngIf="checklistCategory.checklist_subcategories.length > 0" class="table table-bordered">
                  <thead>
                  <tr>
                    <th style="width: 10%;">Codice</th>
                    <th style="width: 20%;">Requisito</th>
                    <th style="width: 30%;">Livello di Servizio</th>
                    <th style="width: 20%;">Documenti di Verifica</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let checklistSubCategory of checklistCategory.checklist_subcategories |
                  paginate: paginationConfig">
                    <td>{{ checklistSubCategory.code }}</td>
                    <td>{{ checklistSubCategory.name }}</td>
                    <td>{{ checklistSubCategory.level }}</td>
                    <td>{{ checklistSubCategory.documents }}</td>
                  </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
        <div *ngIf="checklistCategories.length > 0">
          <pagination-controls (pageChange)="pageChanged($event)"
                               [autoHide]="paginationParams.autoHide"
                               [maxSize]="paginationParams.maxSize"
                               [responsive]="paginationParams.responsive"
                               [previousLabel]="paginationLabels.previousLabel"
                               [nextLabel]="paginationLabels.nextLabel"
                               [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                               [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                               [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
          ></pagination-controls>
        </div>
        <div *ngIf="checklistCategories.length === 0" style="text-align: center; height: 150px; padding-top: 60px;">
          Nessuna Macro Categoria associata.
        </div>
      </div>
      <div *ngIf="user.fk_id_role <= 1" class="panel-footer" style="text-align: center;">
        <a class="btn btn-success" [routerLink]="['/checklist-category/create/' + checklist.id_checklist]"><i class="icon-plus"></i> Aggiungi</a>
      </div>
    </div>
  </div>
</div>
